import { usePlatformSettingsModel } from '@entities/common';
import React from 'react';
import { xhr } from '@shared/config';
import { useAuthToken } from '@shared/hooks/index.ts';
import type { PlatformSettings } from '@shared/types/common';
import { settingsApi } from './api';

export const useLoadCommonSettings = () => {
  const { setSettings } = usePlatformSettingsModel();
  const { token } = useAuthToken();
  const loadSettings = () => {
    const controller = new AbortController();
    const getCommonSettings = async () => {
      try {
        const response = await xhr.get<PlatformSettings>(settingsApi, {
          signal: controller.signal,
        });

        if (!response.data) {
          throw response;
        }

        setSettings(response.data);
      } catch (error) {}
    };

    getCommonSettings();

    return () => {
      controller.abort();
    };
  };
  React.useEffect(loadSettings, [token]);
};
